/**
 * Header row of the "Action required" filter group: a target icon and the group title.
 */
import { observer } from "mobx-react";
import FontBody3 from "../../../../../../components/fonts/font-body3/font-body3";
import { FONT_COLOR } from "../../../../../../components/fonts/font-props";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

const RmaListActionsStatusFilterHeader: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";

    return (
        <div className="rma-list-actions-status-filter__header">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <circle cx="7" cy="7" r="6.5" stroke="var(--color-primary-3-50)" />
                <circle cx="7" cy="7" r="3" stroke="var(--color-primary-3-50)" />
            </svg>
            <FontBody3 color={FONT_COLOR.PRIMARY3_50}>{getTranslation("ACTIONS_STATUS", scope)}</FontBody3>
        </div>
    );
});

export default RmaListActionsStatusFilterHeader;
